import { Pipe, PipeTransform } from '@angular/core';
import { orderBy, get } from 'lodash';

@Pipe({
    name: 'orderBy',
    standalone: false
})
export class OrderByPipe implements PipeTransform {
    transform(array: any[], property: string, reverse = false, caseInsensitive = false): any[] {
        if (!Array.isArray(array) || !property) {
            return array;
        }

        const direction = reverse ? 'desc' : 'asc';

        return orderBy(
            array,
            [
                item => {
                    const value = get(item, property);
                    if (caseInsensitive && typeof value === 'string') {
                        return value.toLowerCase();
                    }
                    return value;
                }
            ],
            [direction]
        );
    }
}
